import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XCircleIcon } from 'lucide-react';
export function MethodPillars() {
  return <>
      {/* ¿QUÉ PODRÁS LOGRAR CON ESTE MÉTODO? */}
      <section className="pt-14 md:pt-20 pb-24 md:pb-32 px-4" style={{
      backgroundColor: '#ffffff'
    }} data-id="element-153">
        <div className="max-w-4xl mx-auto" data-id="element-154">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-155">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-4 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-156">
              🎯 AQUÍ ES DONDE TODO CAMBIA
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-10" style={{
            color: '#1A1614'
          }} data-id="element-157">
              ¿Qué podrás lograr con este método?
            </h2>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5
          }} className="rounded-3xl overflow-hidden shadow-xl mb-14" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/hJPHVrxYxy3DfnYB7GEsUx/ChatGPT_Image_1_abr_2026,_07_39_24_a.m..png" alt="Receta Cinnamon Rolls XL en tablet — Método XL Iconic" loading="lazy" decoding="async" className="w-full object-cover" style={{
              maxHeight: '480px'
            }} data-id="element-159" />
            </motion.div>

            {/* Checkmark items */}
            <div className="space-y-4 mb-14" data-id="element-160">
              {['Lanzar tu primera colección XL en 30 días', 'Crear rolls que parezcan de vitrina profesional', 'Subir tu ticket promedio', 'Diferenciarte de la repostería tradicional', 'Convertir una receta en producto estratégico'].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -12
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.35,
              delay: i * 0.08
            }} className="flex items-center gap-4 bg-white rounded-2xl p-5 shadow-sm border border-gray-100" data-id="element-161">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(7,200,110,0.1)'
              }} data-id="element-162">
                    <CheckIcon className="w-5 h-5" style={{
                  color: '#07c86e'
                }} data-id="element-163" />
                  </div>
                  <p className="text-lg font-medium" style={{
                color: '#1A1614'
              }} data-id="element-164">
                    {item}
                  </p>
                </motion.div>)}
            </div>

            {/* No necesitas */}
            <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100 mb-14" data-id="element-165">
              <p className="text-xl font-bold mb-6" style={{
              color: '#1A1614'
            }} data-id="element-166">
                No necesitas:
              </p>
              <div className="space-y-3 mb-8" data-id="element-167">
                {['No necesitas local.', 'No necesitas maquinaria industrial.', 'No necesitas experiencia previa.'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-168">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="flex-shrink-0" data-id="element-169">
                      <circle cx="10" cy="10" r="10" fill="#e76f51" opacity="0.12" data-id="element-170" />
                      <path d="M6.5 6.5L13.5 13.5M13.5 6.5L6.5 13.5" stroke="#e76f51" strokeWidth="2" strokeLinecap="round" data-id="element-171" />
                    </svg>
                    <p className="text-lg" style={{
                  color: '#5a5248'
                }} data-id="element-172">
                      {item}
                    </p>
                  </div>)}
              </div>
              <p className="text-2xl font-bold" style={{
              color: '#e76f51'
            }} data-id="element-173">
                Necesitas sistema.
              </p>
            </div>

            {/* Audience cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-174">
              {[{
              img: 'https://cdn.magicpatterns.com/uploads/wsig7wWQa2vKoMMaKCgN8U/cook_1f9d1-200d-1f373_(1).png',
              title: 'Si nunca has horneado…',
              lines: ['Está explicado paso a paso.', 'Desde la masa base hasta el montaje final.']
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/xyUDWeknGCD4sQVXhdqCUc/money-mouth-face_1f911.png',
              title: 'Si quieres emprender…',
              lines: ['Aquí tienes sabores en tendencia real.', 'Concepto de edición limitada.', 'Estrategia de rotación.']
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/pYJ48UAS7fyAmLKU5WK21x/8076991d3d9b117497c6ce2f6ea17d41.png',
              title: 'Si ya sabes repostería…',
              lines: ['Esto eleva tu nivel.', 'Más estética. Más impacto.']
            }].map((card, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.45,
              delay: i * 0.12
            }} className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 text-center" data-id="element-175">
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: 'rgba(231,111,81,0.08)'
              }} data-id="element-176">
                    <img src={card.img} alt="" loading="lazy" decoding="async" className="w-10 h-10 object-contain" data-id="element-177" />
                  </div>
                  <h3 className="text-xl font-bold mb-4" style={{
                color: '#1A1614'
              }} data-id="element-178">
                    {card.title}
                  </h3>
                  <div className="space-y-2" data-id="element-179">
                    {card.lines.map((line, j) => <p key={j} className="text-base" style={{
                  color: '#5a5248'
                }} data-id="element-180">
                        {line}
                      </p>)}
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* SOLUCIONES QUE YA INTENTASTE */}
      <section className="py-24 md:py-32 px-4 pt-[50px] pb-[50px]" style={{
      backgroundColor: '#F5EDE4'
    }} data-id="element-181">
        <div className="max-w-4xl mx-auto" data-id="element-182">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-183">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-4 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-184">
              ❌ SOLUCIONES FALLIDAS
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-12" style={{
            color: '#1A1614'
          }} data-id="element-185">
              Las soluciones que probablemente ya intentaste
            </h2>

            <div className="space-y-6 mb-12" data-id="element-186">
              {[{
              title: 'Ver tutoriales gratis en redes',
              desc: 'Información fragmentada. Sin estructura. Sin posicionamiento.'
            }, {
              title: 'Hacer recetas tradicionales',
              desc: 'Rico no es suficiente. El mercado compra percepción.'
            }, {
              title: 'Bajar precios para vender',
              desc: 'Te posiciona como genérica. No como premium.'
            }, {
              title: 'Esperar a "sentirte lista"',
              desc: 'La preparación eterna no reemplaza un sistema.'
            }, {
              title: 'Pensar que necesitas un local',
              desc: 'Eso solo retrasa tu inicio.'
            }].map((item, i) => <div key={i} className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-187">
                  <XCircleIcon className="w-7 h-7 flex-shrink-0 mt-0.5" style={{
                color: '#e76f51'
              }} data-id="element-188" />
                  <div data-id="element-189">
                    <p className="text-lg font-bold mb-1" style={{
                  color: '#1A1614'
                }} data-id="element-190">
                      {item.title}
                    </p>
                    <p className="text-base" style={{
                  color: '#5a5248'
                }} data-id="element-191">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="text-center space-y-3" data-id="element-192">
              <p className="text-xl" style={{
              color: '#5a5248'
            }} data-id="element-193">
                El problema nunca fue la receta.
              </p>
              <p className="text-2xl font-bold" style={{
              color: '#e76f51'
            }} data-id="element-194">
                Fue no tener un sistema diseñado para el mercado actual.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}